import { Box, Button, Flex, Input, Menu, Select, Text } from "@mantine/core";

import { useDisclosure } from "@mantine/hooks";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import NoteTypeSelectModal from "../../../components/NoteSelectTypeModal";
import NoteTable from "../../../components/NoteTable";
import CustomPagination from "../../../components/Pagination/CustomPagination";
import { getAllFacilitiesModal, getAllFacilityTypes } from "../../../services";
import {
  getAllNoteTypes,
  getNotes,
  getSingleNote,
} from "../../../services/note";
import { getAllPatientsModal } from "../../../services/patient";
import { getAllStaff } from "../../../services/staff";
import { getAllPlans } from "../../../services/supportplan";
import { DatePickerInput } from "@mantine/dates";
import moment from "moment";
import useStyles from "./style";
import { TrackPageView } from "../../../config/mixpanelConfig";
import AddEssentialNote from "../../../components/AddEssentialNote/AddEssentialNote";
import { Billing_Services_Note, Essential_Support_Note } from "../../../http";
import { getBillingProvider } from "../../../services/billingprovider";
import AppNavbar from "../../../components/AppNavbar/AppNavbar";
import NoteDrawer from "../../../components/NoteModal/NewNoteDesignCopy";
import { IoFilter, IoSettingsOutline } from "react-icons/io5";
import { NewAddButton } from "../../../components/AddButton/NewAddButton";
import { NotetTypeSvg } from "../../../components/Svgs/NotetTypeSvg";
import { RxCross2 } from "react-icons/rx";
import { IconSearch } from "@tabler/icons-react";
import useDebounce from "../../../utils/useDebounce";
import { clearNotes } from "../../../store/reducers/note";
import { FaSort } from "react-icons/fa6";
import { getSkaiTokenUsage } from "../../../services/skaiTokens";
import { PDFDownloadLink } from "@react-pdf/renderer";
import NoteReportPDF from "../../../components/NoteReportPDF";
import { ReportSvg } from "../../../components/Svgs/ReportSvg";
import NoteReportDrawer from "../../../components/NoteReportModal";
import { getAllSignatures } from "../../../services/signature";
import NoteModalNew from "../../../components/NoteModal/NoteModalNew";
import ServiceDeliveryLogPdf from "../../../components/ServiceDeliveryLogPdf";

const Note = (props) => {
  const { notes, loading } = useSelector((state) => state?.note);
  const { singleNote } = useSelector((state) => state?.note);
  const { profile } = useSelector((state) => state.profile);
  const [data, setData] = useState(null);
  const [view, setView] = useState(false);
  const [isopen, setOpen] = useState(false);
  const [isViewNoteOpen, setIsViewNoteOpen] = useState(false);
  const [noteType, setNoteType] = useState(null);
  const [dateRange, setDateRange] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [sortOpen, setSortOpen] = useState(false);
  const [dateRangeVal, setDateRangeVal] = useState([]);
  const [opened, { open, close }] = useDisclosure(false);
  const [oneDayValue, setOneDayValue] = useState(null);
  const [sortField, setSortField] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("descending");
  const [openModal, setOpenModal] = useState(false);
  const [billingServices, setBillingServices] = useState("");
  const [progressNoteState, setProgressNoteState] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [
    noteReportDrawerOpened,
    { open: noteReportDrawerOpen, close: noteReportDrawerClose },
  ] = useDisclosure(false);
  const navigate = useNavigate();
  const { classes } = useStyles();

  const debouncedSearch = useDebounce(searchTerm, 2000);

  useEffect(() => {
    if (debouncedSearch) {
      getNotes(
        currentPage,
        null,
        true,
        dateRange,
        sortField,
        sortOrder,
        debouncedSearch
      );
    } else {
      getNotes(currentPage, null, true, dateRange, sortField, sortOrder);
    }
  }, [debouncedSearch]);

  useEffect(() => {
    getAllPlans();
    getAllNoteTypes();
    getAllFacilityTypes();
    getAllPatientsModal("withDeleted");
    getAllFacilitiesModal("withDeleted");
    getAllStaff("all");
    getBillingProvider();
    getAllSignatures();

    TrackPageView("Note");
  }, []);

  useEffect(() => {
    getNotes(currentPage, null, true, dateRange, sortField, sortOrder);
  }, [currentPage, dateRange]);

  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearNotes());
    };
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const noteId = params.get("noteId");
    if (noteId) {
      getSingleNote(noteId);
      setOpen(true);
    }
  }, []);

  useEffect(() => {
    if (singleNote) {
      setData(singleNote);
    }
  }, [singleNote]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleDateRange = (dates) => {
    if (dates[0] == null && dates[1] == null) {
      setDateRangeVal([]);
    } else {
      setDateRangeVal(dates);
    }
  };

  const handleDateChange = (date) => {
    setOneDayValue(date);
  };

  const handleSaveDateRange = () => {
    if (dateRangeVal?.length) {
      let startDate = moment(dateRangeVal[0]).startOf("day");
      let endDate = moment(dateRangeVal[1]).endOf("day");
      setDateRange([startDate, endDate]);
    } else if (oneDayValue) {
      let startDate = moment(oneDayValue).startOf("day");
      let endDate = moment(oneDayValue).endOf("day");
      setDateRange([startDate, endDate]);
    }
    setDropdownOpen(false);
  };

  const handleSaveSort = () => {
    getNotes(currentPage, null, true, dateRange, sortField, sortOrder);
    setSortOpen(false);
  };

  const handleSortChange = (field, order) => {
    setSortField(field);
    setSortOrder(order);
  };

  const handleCancelDateRange = () => {
    setDateRangeVal([]);
    setDateRange(null);
    setDropdownOpen(false);
  };

  const handleResetSort = () => {
    setSortField("createdAt");
    setSortOrder("descending");
    getNotes(currentPage, null, true, dateRange, "createdAt", "descending");
    setSortOpen(false);
  };

  const handleAddEssential = () => {
    if (billingServices) {
      setNoteType(Billing_Services_Note);
    } else {
      setNoteType(Essential_Support_Note);
    }
    setOpen(true);
  };

  return (
    <Box fluid className={classes.content}>
      <AddEssentialNote
        openModal={openModal}
        setOpenModal={setOpenModal}
        onConfirm={handleAddEssential}
        billingServices={billingServices}
        setBillingServices={setBillingServices}
      />
      <NoteDrawer
        data={data}
        // view={view}
        opened={isopen}
        // setView={setView}
        noteType={noteType}
        title={"Add New Note"}
        close={() => {
          setOpen(false);
          setData(null);
          setNoteType();
        }}
        sortField={sortField}
        sortOrder={sortOrder}
        setOpenModal={setOpenModal}
        setBillingServices={setBillingServices}
        setProgressNoteState={setProgressNoteState}
        progressNoteState={progressNoteState}
      />

      <NoteModalNew
        opened={isViewNoteOpen}
        close={() => {
          setIsViewNoteOpen(false);
          setData(null);
        }}
        hideApproveRejectButtons={true}
        noteType={noteType}
        title={"Add New Note"}
        view={view}
        setView={setView}
        data={data}
      />

      <AppNavbar title={"Note"} profile={profile} />

      <Box className={classes.btn} px={20} mx={20}>
        <Flex align={"center"} gap={10}>
          <Text className={classes.titleText}>All Notes</Text>
          {/* Sorting */}
          <Box className={classes.rightBTN}>
            <Menu
              width={350}
              shadow="md"
              radius={"md"}
              opened={sortOpen}
              position="bottom-start"
              onClose={() => setSortOpen(false)}
            >
              <Menu.Target title="Sort">
                <Box
                  className={classes.FilterIcon}
                  onClick={() => setSortOpen(!sortOpen)}
                >
                  <FaSort size={30} />
                </Box>
              </Menu.Target>

              <Menu.Dropdown>
                <Box className={classes.box_header}>
                  <Text size="md" weight={500} mt={10} mb={5}>
                    Sorting
                  </Text>
                  <Button variant="unstyled" p={0} onClick={handleResetSort}>
                    <RxCross2 />
                  </Button>
                </Box>
                <Box className={classes.box_body}>
                  <Select
                    label="Sort By"
                    placeholder="Sort by"
                    data={[
                      { label: "Created Date", value: "createdAt" },
                      { label: "Note Date", value: "noteDate" },
                      { label: "Edited Date", value: "updatedAt" },
                    ]}
                    value={sortField}
                    onChange={(value) => handleSortChange(value, sortOrder)}
                  />
                  <Select
                    label="Sort Order"
                    placeholder="Sort Order"
                    data={[
                      { label: "Ascending", value: "ascending" },
                      { label: "Descending", value: "descending" },
                    ]}
                    value={sortOrder}
                    onChange={(value) => handleSortChange(sortField, value)}
                  />
                </Box>
                <Box className={classes.btn_container}>
                  <Button
                    size="sm"
                    radius={"md"}
                    color="gray"
                    variant="outline"
                    onClick={handleResetSort}
                  >
                    Reset
                  </Button>
                  <Button
                    size="sm"
                    radius={"md"}
                    // color="yellow"
                    disabled={loading}
                    onClick={handleSaveSort}
                    style={{
                      backgroundColor: "#000",
                    }}
                  >
                    Save
                  </Button>
                </Box>
              </Menu.Dropdown>
            </Menu>
          </Box>
        </Flex>
        <Box className={classes.rightBTN}>
          {/* <PDFDownloadLink
            document={<ServiceDeliveryLogPdf />}
            fileName="service-delivery-log.pdf"
            style={{
              backgroundColor: "#2563eb",
              color: "white",
              padding: "12px 24px",
              borderRadius: "8px",
              textDecoration: "none",
              fontWeight: "600",
              fontSize: "16px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              transition: "all 0.2s",
              cursor: "pointer",
            }}
          >
            {({ blob, url, loading, error }) =>
              "Download PDF"
            }
          </PDFDownloadLink> */}
          {/* filter */}
          <Menu
            width={350}
            shadow="md"
            radius={"md"}
            opened={dropdownOpen}
            position="bottom"
            onClose={() => setDropdownOpen(false)}
          >
            <Menu.Target title="Filter">
              <Button
                size="md"
                radius="md"
                title="Filter"
                leftIcon={<IoFilter />}
                onClick={() => setDropdownOpen(!dropdownOpen)}
                color="gray"
                variant="outline"
              >
                Filter
              </Button>
            </Menu.Target>

            <Menu.Dropdown>
              <Box className={classes.box_header}>
                <Text size="lg" weight={500}>
                  Filter
                </Text>
                <Button
                  variant="unstyled"
                  p={0}
                  onClick={handleCancelDateRange}
                >
                  <RxCross2 />
                </Button>
              </Box>
              <Box className={classes.box_body}>
                <Box className={classes.filterFields}>
                  <DatePickerInput
                    size="sm"
                    radius={"md"}
                    clearable
                    // m={".5rem"}
                    type="range"
                    value={dateRangeVal}
                    disabled={oneDayValue}
                    label="Select Date Range"
                    onChange={handleDateRange}
                    placeholder="Select Date Range"
                  />
                </Box>
                <Box className={classes.filterFields}>
                  <DatePickerInput
                    radius={"md"}
                    clearable
                    size="sm"
                    // m={".5rem"}
                    value={oneDayValue}
                    label="Select Date"
                    placeholder="Select Date"
                    onChange={handleDateChange}
                    disabled={dateRangeVal?.length}
                  />
                </Box>
              </Box>
              <Box className={classes.btn_container}>
                <Button
                  size="sm"
                  radius={"md"}
                  color="gray"
                  variant="outline"
                  onClick={handleCancelDateRange}
                >
                  Reset
                </Button>
                <Button
                  radius={"md"}
                  size="sm"
                  disabled={loading}
                  onClick={handleSaveDateRange}
                  style={{
                    backgroundColor: "#000",
                  }}
                >
                  Apply
                </Button>
              </Box>
            </Menu.Dropdown>
          </Menu>
          <NewAddButton
            title="Add Note"
            icon={<NotetTypeSvg />}
            onClick={() => {
              getAllStaff("all");
              setOpen(true);
            }}
            color="#FFAF4A"
            textColor="#000"
            variant="filled"
            borderColor="none"
          />
          <NewAddButton
            title="Create Report"
            icon={<ReportSvg />}
            onClick={noteReportDrawerOpen}
            color="#FFAF4A"
            textColor="#000"
            variant="filled"
            borderColor="none"
          />

          {profile?.user?.type !== "staff" &&
            profile?.user?.role !== "staff" &&
            profile?.user?.role !== "admin" && (
              <NewAddButton
                title="Settings"
                icon={<IoSettingsOutline />}
                onClick={() => navigate("/home/notetype")}
                color="#000"
                textColor="#fff"
                variant="filled"
                borderColor="none"
              />
            )}
        </Box>
      </Box>
      <Box className={classes.search_container} px={20} mx={20}>
        <Input
          icon={<IconSearch />}
          placeholder="Search"
          className={classes.searchInput}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </Box>
      <Box className={classes.noteTable} px={20}>
        <NoteTable
          openModal={(data) => {
            setView(false);
            setData(data);
            setOpen(true);
          }}
          openViewModal={(data) => {
            setData(data);
            setIsViewNoteOpen(true);
          }}
          setView={(data) => {
            setView(true);
          }}
          sortField={sortField}
          sortOrder={sortOrder}
          setOpenModal={setOpenModal}
          setOpen={setOpen}
          // loading={loading}
        />
        {notes?.notes?.length > 0 ? (
          <CustomPagination
            itemsPerPage={10}
            data={notes?.count}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
          />
        ) : (
          ""
        )}
        <NoteTypeSelectModal
          save={setOpen}
          opened={opened}
          title={"Add Note"}
          onclose={(nType) => {
            close();
            setNoteType(nType);
          }}
        />
        <NoteReportDrawer
          drawerOpen={noteReportDrawerOpened}
          drawerClose={noteReportDrawerClose}
        />
      </Box>
    </Box>
  );
};

export default Note;
